module.exports = __webpack_public_path__ + "static/hero-video-with-overlay-f30dfb9715516b7fb23d3b2cdc9759a4.mp4";